<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-btn x-small fab absolute top right color="primary" class="mt-7" @click="showImportDialog=true">
        <v-icon>mdi-application-import</v-icon>
      </v-btn>

      <v-col cols="6">
        <v-card>
          <v-card-title>Contact</v-card-title>
          <v-card-subtitle>The person</v-card-subtitle>
          <ContactEditor ref="contactEditor" v-model="contact"/> <!-- call fetchContact to get the contents -->
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card>
          <v-card-title>Client</v-card-title>
          <v-card-subtitle>The company</v-card-subtitle>
          <ClientEditor ref="clientEditor" v-model="client"/>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn color="primary" @click="save">Save</v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="showImportDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Import from contact form
        </v-card-title>

        <v-card-text>
          <ClientImporter @import="clientImported"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ContactEditor from "../contacts/ContactEditor"
import ClientEditor from "../clients/ClientEditor"
import ClientImporter from "@/components/clients/ClientImporter"

// const businessStructureUuid = "9c483d77-1c57-43ec-afce-4f60fdc6062f"
// const clientTypeUuid = "9c483d77-0377-4da5-846e-f89cc4267db4"

export default {
  name: "CreateProspect",
  props: {
    "UUID": {type: String}
  },
  permissions: ["Modify Client", "Modify Contact", ...ClientImporter.permissions, ...ContactEditor.permissions, ...ClientEditor.permissions],
  components: {
    ClientImporter, ContactEditor, ClientEditor
  },
  methods: {
    initialize() {
      this.client = {
        name: "",
        address: "",
        city: "",
        region: "",
        postCode: "",
        country: "",
        postalAddress: "",
        postalCity: "",
        postalRegion: "",
        postalPostCode: "",
        postalCountry: "",
        postalPhone: "",
        website: "",
        isProspect: "",
        referralSource: "",
      }
      this.contact = {
        name: "",
        phone: "",
        mobile: "",
        email: "",
        position: "",
      }
    },
    save() {
      const client = this.$refs.clientEditor.getClient()
      const clientPayloadV2 = {
        name: client.name,
        //firstName,
        //firstName
        //otherName
        //email
        //phone
        //fax
        webSite: client.website,
        referralSource: client.referralSource,
        clientManagerUuid: this.$access.wfm_uuid,
        jobManagerUuid: this.$access.wfm_uuid,
        // businessStructureUuid: businessStructureUuid,
        // clientTypeUuid: clientTypeUuid,
        // favorite
        addresses: [{
          type: "postal", // or billing
          default: true,
          address: client.address,
          city: client.city,
          state: client.region,
          postCode: client.postCode,
          country: client.country,
        },
          {
            type: "postal", // or billing
            default: true,
            address: client.address,
            city: client.city,
            state: client.region,
            postCode: client.postCode,
            country: client.country,
          }],
        //tfn
        //abn
        //branch
        //acn
        //vatNumber
        //companyNumber
        //irdNumber
        //nzbn
        //taxNumber
        //yearEndDate
        //balanceDate
        //zeroRatedTaxUuid
        //billingClientUuid
        //customRate
        //markup
        //customPaymentDay
        //groups
        //contacts
        //exportCode
        //relationships
        //customFields

      }

    const contact = this.$refs.contactEditor.getContact()
    const contactPayload = {
      Contact: {
        Client: null,
        Name: contact.name,
        Phone: contact.phone,
        Mobile: contact.mobile,
        Email: contact.email,
        Position: contact.position,
        IsPrimary: 'yes'
      }
    }

    this.$WfmApi.post("clients", clientPayloadV2).then((clientRes) => {
      console.log(clientRes)
      // this.$refs.clientEditor.saveCustomFields(clientRes.Client.UUID) // currently no custom fields
      contactPayload['Contact']['Client'] = {UUID: clientRes.uuid}
      this.$WfmApi.post("client.api/contact", contactPayload).then((contactRes) => {
        const ret = clientRes
        ret.UUID = ret.uuid // v2 vs v1 inconsistency
        ret.Contacts = {Contact: contactRes.Contact}
        ret.Contacts.Contact.UUID = contactRes.UUID // not part of the contact object but should be
        this.$emit("saved", ret)
      })
    })
  },
  clientImported(data) {
    this.client = {
      name: data.company,
      city: data.location,
      region: data.location,
      country: data.country,
      isProspect: true,
      referralSource: data.contactMethod,
    }
    this.contact = {
      name: data.name,
      phone: "",
      mobile: data.phone,
      email: data.email,
      position: data.position
    }
    this.showImportDialog = false
  }
}
,
mounted()
{
  this.initialize()
}
,
data()
{
  return {
    title: "Client",
    showTitle: true,
    editable: false,
    isReady: true,
    settings: {},
    showImportDialog: false,
    client: {},
    contact: {}
  }
}
,
}

</script>

<style scoped>
</style>